export const SEVERITIES = {
    WARNING: "WARNING",
    INFO: "INFO",
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
};
